const arc = (cx, cy, rx, ry, from = 0, to = 360, step = 18) => {
    const pts = [];
    const dir = to >= from ? 1 : -1;
    for (let a = from; dir > 0 ? a <= to : a >= to; a += Math.abs(step) * dir) {
        const r = (a * Math.PI) / 180;
        pts.push([cx + Math.cos(r) * rx, cy + Math.sin(r) * ry]);
    }
    return pts;
};
const ring = (cx, cy, r) => arc(cx, cy, r, r, 0, 360, 20);
const spiral = (cx, cy, r, turns = 2.5) => {
    const pts = [];
    for (let i = 0; i <= turns * 18; i++) {
        const t = i / (turns * 18);
        const a = t * turns * 2 * Math.PI;
        pts.push([cx + Math.cos(a) * r * t, cy + Math.sin(a) * r * t]);
    }
    return pts;
};
const star = (cx, cy, R, r) => {
    const pts = [];
    for (let i = 0; i <= 10; i++) {
        const a = -Math.PI / 2 + (i * Math.PI) / 5;
        const rad = i % 2 === 0 ? R : r;
        pts.push([cx + Math.cos(a) * rad, cy + Math.sin(a) * rad]);
    }
    return pts;
};
const heart = (cx, cy, s) => {
    const pts = [];
    for (let i = 0; i <= 36; i++) {
        const t = (i / 36) * 2 * Math.PI;
        const x = 16 * Math.sin(t) ** 3;
        const y = -(13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t));
        pts.push([cx + x * s, cy + y * s]);
    }
    return pts;
};
const RAW = {
    castle: [
        [[25, 65], [25, 30], [75, 30], [75, 65], [25, 65]],
        [[25, 30], [25, 22], [32, 22], [32, 30], [39, 30], [39, 22], [46, 22], [46, 30], [54, 30], [54, 22], [61, 22], [61, 30], [68, 30], [68, 22], [75, 22], [75, 30]],
        [[44, 65], [44, 54], ...arc(50, 54, 6, 6, 180, 360), [56, 65]],
        [[50, 22], [50, 10], [59, 13], [50, 16]],
    ],
    crown: [
        [[25, 55], [25, 28], [37, 44], [50, 22], [63, 44], [75, 28], [75, 55], [25, 55]],
        ring(37, 50, 2.5),
        ring(50, 50, 2.5),
        ring(63, 50, 2.5),
    ],
    candle: [
        [[42, 65], [42, 30], [58, 30], [58, 65]],
        arc(50, 66, 16, 4),
        [[50, 30], [50, 25]],
        [[50, 25], [45, 18], [50, 7], [55, 18], [50, 25]],
    ],
    key: [ring(28, 37, 11), [[39, 37], [82, 37]], [[70, 37], [70, 46]], [[78, 37], [78, 46]]],
    ghost: [
        [[35, 66], [35, 30], ...arc(50, 30, 15, 15, 180, 360), [65, 66], [60, 61], [55, 66], [50, 61], [45, 66], [40, 61], [35, 66]],
        ring(44, 32, 2.2),
        ring(56, 32, 2.2),
        arc(50, 43, 3, 4),
    ],
    sword: [
        [[48, 50], [48, 12], [50, 5], [52, 12], [52, 50]],
        [[37, 50], [63, 50]],
        [[50, 50], [50, 64]],
        ring(50, 67, 3),
    ],
    moon: [[...arc(50, 37, 24, 24, 60, 300, 12), ...arc(60, 37, 19, 19, 255, 105, -12)]],
    ship: [
        [[18, 50], [82, 50], [71, 62], [29, 62], [18, 50]],
        [[50, 50], [50, 10]],
        [[50, 13], [74, 43], [50, 43]],
        [[8, 69], [18, 65], [28, 69], [38, 65], [48, 69], [58, 65], [68, 69], [78, 65], [88, 69]],
    ],
    tree: [[[45, 70], [45, 50]], [[55, 70], [55, 50]], ring(50, 28, 15), ring(36, 40, 11), ring(64, 40, 11)],
    snowman: [ring(50, 56, 15), ring(50, 31, 10), ring(46, 29, 1.2), ring(54, 29, 1.2), [[50, 32], [59, 33], [50, 34]], [[40, 22], [60, 22]], [[43, 22], [43, 12], [57, 12], [57, 22]]],
    umbrella: [
        [...arc(50, 40, 27, 24, 180, 360)],
        [[23, 40], [30, 36], [37, 40], [43, 36], [50, 40], [57, 36], [63, 40], [70, 36], [77, 40]],
        [[50, 40], [50, 63], ...arc(46, 63, 4, 4, 0, 180)],
    ],
    glasses: [ring(34, 40, 10), ring(66, 40, 10), [[44, 37], [50, 34], [56, 37]], [[24, 38], [13, 32]], [[76, 38], [87, 32]]],
    hat: [arc(50, 56, 28, 5), [[36, 56], [38, 20], [62, 20], [64, 56]], [[37, 48], [63, 48]]],
    clock: [ring(50, 37, 25), [[50, 37], [50, 21]], [[50, 37], [62, 43]], [[50, 14], [50, 17]], [[73, 37], [70, 37]], [[50, 60], [50, 57]], [[27, 37], [30, 37]]],
    kite: [
        [[50, 8], [67, 31], [50, 56], [33, 31], [50, 8]],
        [[50, 8], [50, 56]],
        [[33, 31], [67, 31]],
        [[50, 56], [44, 61], [55, 65], [45, 69], [54, 73]],
    ],
    balloon: [arc(50, 29, 15, 19), [[47, 48], [50, 51], [53, 48]], [[50, 51], [46, 58], [54, 65], [49, 73]]],
    anchor: [ring(50, 12, 4), [[50, 16], [50, 63]], [[38, 25], [62, 25]], [...arc(50, 46, 18, 17, 0, 180)], [[32, 46], [27, 51]], [[68, 46], [73, 51]]],
    tent: [[[20, 65], [50, 13], [80, 65], [20, 65]], [[42, 65], [50, 40], [58, 65]], [[8, 66], [92, 66]]],
    mushroom: [[...arc(50, 40, 23, 20, 180, 360), [27, 40], [73, 40]], [[42, 40], [41, 64], [59, 64], [58, 40]], ring(42, 30, 3), ring(56, 27, 3), ring(63, 35, 2)],
    carrot: [[[30, 22], [40, 17], [76, 62], [30, 22]], [[33, 20], [22, 7]], [[36, 19], [32, 4]], [[39, 18], [44, 6]], [[42, 30], [47, 28]], [[52, 40], [56, 38]]],
    cake: [
        [[24, 63], [24, 40], [76, 40], [76, 63], [24, 63]],
        [[24, 47], [31, 51], [38, 47], [45, 51], [52, 47], [59, 51], [66, 47], [76, 51]],
        [[40, 40], [40, 29]],
        [[50, 40], [50, 29]],
        [[60, 40], [60, 29]],
        [[40, 28], [38, 24], [40, 20], [42, 24], [40, 28]],
        [[50, 28], [48, 24], [50, 20], [52, 24], [50, 28]],
        [[60, 28], [58, 24], [60, 20], [62, 24], [60, 28]],
    ],
    teapot: [arc(50, 46, 21, 15), [[40, 31], [60, 31]], ring(50, 27, 3), [[30, 46], [17, 33], [21, 30]], arc(70, 46, 9, 9, -90, 90)],
    spider: [
        ring(50, 41, 8),
        ring(50, 29, 5),
        [[44, 37], [30, 27], [24, 35]],
        [[43, 41], [27, 39], [20, 48]],
        [[44, 45], [30, 51], [26, 61]],
        [[56, 37], [70, 27], [76, 35]],
        [[57, 41], [73, 39], [80, 48]],
        [[56, 45], [70, 51], [74, 61]],
    ],
    snail: [spiral(56, 41, 17), [[18, 60], [76, 60], [82, 55]], [[20, 60], [17, 50], [24, 50], [25, 60]], [[18, 50], [13, 40]], [[22, 50], [24, 40]]],
    rocket: [
        [[50, 6], [61, 21], [61, 54], [39, 54], [39, 21], [50, 6]],
        ring(50, 29, 5),
        [[39, 43], [29, 60], [39, 54]],
        [[61, 43], [71, 60], [61, 54]],
        [[44, 54], [50, 71], [56, 54]],
    ],
    diamond: [[[28, 30], [39, 17], [61, 17], [72, 30], [50, 63], [28, 30]], [[28, 30], [72, 30]], [[39, 17], [45, 30], [50, 63]], [[61, 17], [55, 30], [50, 63]]],
    lollipop: [spiral(50, 27, 17, 3), [[50, 44], [50, 73]]],
    ladder: [[[38, 6], [38, 70]], [[62, 6], [62, 70]], [[38, 16], [62, 16]], [[38, 28], [62, 28]], [[38, 40], [62, 40]], [[38, 52], [62, 52]], [[38, 64], [62, 64]]],
    cactus: [
        [[45, 66], [45, 22], ...arc(50, 22, 5, 5, 180, 360), [55, 66]],
        [[45, 46], [36, 46], [36, 31]],
        [[55, 39], [64, 39], [64, 25]],
        [[34, 66], [66, 66], [62, 74], [38, 74], [34, 66]],
    ],
    trophy: [
        [[35, 14], [65, 14], [62, 40], [50, 46], [38, 40], [35, 14]],
        arc(35, 24, 7, 8, 90, 270),
        arc(65, 24, 7, 8, -90, 90),
        [[50, 46], [50, 57]],
        [[37, 57], [63, 57], [63, 64], [37, 64], [37, 57]],
    ],
    sun: [
        ring(50, 37, 13),
        [[50, 18], [50, 9]], [[50, 56], [50, 65]], [[31, 37], [22, 37]], [[69, 37], [78, 37]],
        [[37, 24], [31, 18]], [[63, 24], [69, 18]], [[37, 50], [31, 56]], [[63, 50], [69, 56]],
    ],
    fish: [arc(48, 37, 23, 13), [[71, 37], [85, 26], [85, 48], [71, 37]], ring(36, 34, 2), [[30, 42], [36, 43]]],
    house: [[[25, 66], [25, 36], [75, 36], [75, 66], [25, 66]], [[19, 38], [50, 12], [81, 38]], [[44, 66], [44, 50], [56, 50], [56, 66]], [[30, 42], [40, 42], [40, 51], [30, 51], [30, 42]], [[60, 42], [70, 42], [70, 51], [60, 51], [60, 42]]],
    heart: [heart(50, 38, 1.6)],
    star: [star(50, 38, 27, 11)],
    apple: [[...arc(43, 45, 15, 17, 90, 270), ...arc(57, 45, 15, 17, -90, 90)], [[50, 29], [52, 18]], [[52, 23], [62, 18], [56, 27]]],
};
/** The words Portrait Gallery deals. */
export const SKETCH_WORDS = Object.keys(RAW);
/** A word's sketch, as strokes of flattened x, y pairs on the 1000 × 750 canvas. */
export function sketchFor(word) {
    return (RAW[word] ?? []).map((stroke) => stroke.flatMap(([x, y]) => [Math.round(x * 10), Math.round(y * 10)]));
}
//# sourceMappingURL=sketches.js.map